import React, { useState } from 'react'
import { Tooltip } from 'reactstrap'

const ImageWithTooltip = ({
  id,
  image,
  describe,
  fn = () => {},
  className
}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  return (
    <div>
      {image == [] || image === '[]' ? (
        <i
          id={`TooltipTopImage-${id}`}
          className={`${className ? className : ''} far fa-user-circle font-size-32 user-photo-label`}
          aria-hidden="true"
        />
      ) : (
        <img
          id={`TooltipTopImage-${id}`}
          src={image}
          onClick={fn}
          alt=""
          style={{ objectFit: 'contain', cursor: 'pointer' }}
          className={`${className ? className : ''} rounded-circle avatar-xs`}
        />
      )}
      {describe && (
        <Tooltip
          placement="top"
          isOpen={showTooltip}
          target={`TooltipTopImage-${id}`}
          className="tooltip-table-dinamic"
          toggle={() => {
            setShowTooltip(!showTooltip)
          }}
        >
          {describe}
        </Tooltip>
      )}
    </div>
  )
}

export default ImageWithTooltip
